module.exports = __webpack_public_path__ + "static/media/certificate_of_software_intern.9814414f.9814414f.png";